import { render, staticRenderFns } from "./MudarEpoca.vue?vue&type=template&id=6e0eba56&"
import script from "./MudarEpoca.vue?vue&type=script&lang=js&"
export * from "./MudarEpoca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports